export const calculateReadTime = (interaction) => {
    if (interaction.SecureMessageReadUtc && interaction.SecureMessageSentUtc) {
        try {
            const readTime = new Date(interaction.SecureMessageReadUtc).getTime();
            const sentTime = new Date(interaction.SecureMessageSentUtc).getTime();
            return Math.floor((readTime - sentTime) / 1000);
        }
        catch (error) {
            return 0;
        }
    }
    return 0;
};
export const calculateCallbackTime = (interaction) => {
    if (interaction.CallbackFromMessageIdUtc && interaction.SecureMessageSentUtc) {
        try {
            const callbackTime = new Date(interaction.CallbackFromMessageIdUtc).getTime();
            const sentTime = new Date(interaction.SecureMessageSentUtc).getTime();
            return Math.floor((callbackTime - sentTime) / 1000);
        }
        catch (error) {
            return 0;
        }
    }
    return 0;
};
export const calculateNotificationTime = (interaction) => {
    if (!interaction.PushNotificationSentUtc) {
        return { time: 0, canCalculate: false };
    }
    if (!interaction.PushNotificationReceivedUtc) {
        return { time: 0, canCalculate: false };
    }
    try {
        const receivedTime = new Date(interaction.PushNotificationReceivedUtc).getTime();
        const sentTime = new Date(interaction.PushNotificationSentUtc).getTime();
        const diffInSeconds = Math.round((receivedTime - sentTime) / 1000);
        if (Math.abs(diffInSeconds) < 1) {
            return { time: 0, canCalculate: true };
        }
        return { time: Math.max(0, diffInSeconds), canCalculate: true };
    }
    catch (error) {
        console.error("Error calculating notification time:", error);
        return { time: 0, canCalculate: false };
    }
};
//# sourceMappingURL=interactionCalculations.js.map